/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function() {

// Newsletter Popup open on menu click (Desktop)

$('li.HorizontalList__Item a').click(function () {
  //alert($(this).text());                
  var href = $(this).attr('href');
  if (href == "#WOM")
  {
    $(".NewsletterPopup").attr("aria-hidden","false");
  }

});



// Newsletter Popup open on menu click (Mobile)

$('#sidebar-menu .Collapsible a').click(function () {
  //alert($(this).text());                
  var href = $(this).attr('href');
  if (href == "#WOM")
  {
    $("#sidebar-menu").attr("aria-hidden","true");
	//$(".PageOverlay").removeClass("is-visible");
    $(".NewsletterPopup").attr("aria-hidden","false");
  }

});

// cart page register now button
  // Note: to run script on cart page used "body", do not change it 

  $('body').on( "click", "#register_now", function() {
  
    $(".NewsletterPopup").attr("aria-hidden","false");
  
  
});

//   $('#collection-filter-drawer').click(function(){
    
//     $('.Collapsible__Inner').css({"height": "auto", "visibility": "visible"});
    
//     )};

});